import routes from './routes'

export { routes }



// WEBPACK FOOTER //
// ./src/containers/Unsubscribe/index.js